import { VKVideoContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"
import VKVideoButton from "src/libs/useful/vkVideoButton"

/* Protopia Ecosystem component */  
const VKVideoPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: VKVideoContent  = ( props.primitive || {} ) as VKVideoContent 
        return !!primitive.src
            ?
            <VKVideoButton {...{...primitive, label: primitive.label || "", isAutoMode: true, isPlayButton: true }} />
            :
            <></>
}
export default VKVideoPrimitive